export default __webpack_public_path__ + "static/media/error-light.46fa66d3.svg";